import posthog from 'posthog-js'

import { getEnv } from '@/app/get-env'

const SENSITIVE_ROUTES = ['/login', '/logout', '/refresh_token']

const SENSITIVE_BODY_PATTERN =
  /"(password|token|secret|apikey)"\s*:\s*"[^"]*"/gi

const init = () => {
  if (getEnv() !== 'production') return

  posthog.init('phc_BTFraJkwaa2QovFXUcq3rkT3bTtgifUx98ps06U7nH8', {
    api_host: 'https://app.posthog.com',
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: { password: true },
      recordCrossOriginIframes: true,
      recordHeaders: true,
      recordBody: true,
      maskCapturedNetworkRequestFn: request => {
        if (SENSITIVE_ROUTES.some(route => request.name?.includes(route))) {
          request.requestBody = undefined
          request.responseBody = undefined
        }

        const redactHeaders = (
          headers?: Record<string, string | undefined>
        ) => {
          if (!headers) return
          delete headers.authorization
          delete headers.Authorization
          delete headers.cookie
          delete headers.Cookie
          delete headers['set-cookie']
          delete headers['Set-Cookie']
          delete headers['x-api-key']
          delete headers['X-Api-Key']
          delete headers['x-auth-token']
          delete headers['X-Auth-Token']
        }

        redactHeaders(request.requestHeaders)
        redactHeaders(request.responseHeaders)

        const redactBody = (body?: string | null) =>
          body?.replace(SENSITIVE_BODY_PATTERN, '"$1":"[REDACTED]"')

        request.requestBody = redactBody(request.requestBody)
        request.responseBody = redactBody(request.responseBody)

        return request
      }
    }
  })
}

type IdentifyUser = {
  id?: string
  name?: string
  email?: string
}

const identify = ({ id, name, email }: IdentifyUser) => {
  if (getEnv() !== 'production') return
  if (!id) return

  posthog.identify(id, { name, email })
}

export const postHogService = {
  init,
  identify
}

export { default as posthog } from 'posthog-js'
